import { useState, useEffect } from 'react';

const useDeviceType = () => {
  // Initialize with immediate device check to prevent flash
  const [isMobile, setIsMobile] = useState(() => {
    // Only check if window is available (not during SSR)
    if (typeof window !== 'undefined') {
      const width = window.innerWidth;
      const height = window.innerHeight;
      return width <= height * 0.9; // Check if width is <= 90% of height
    }
    return false; // Default fallback for SSR
  });

  useEffect(() => {
    const checkDeviceType = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      setIsMobile(width <= height * 0.9); // Check if width is <= 90% of height
    };

    // Check on mount (in case the initial calculation was during SSR)
    checkDeviceType();

    // Add event listener for window resize
    window.addEventListener('resize', checkDeviceType);

    // Cleanup
    return () => window.removeEventListener('resize', checkDeviceType);
  }, []);

  return { isMobile };
};

export default useDeviceType;